import { useLang } from 'hooks/lang';

import { ProjectInvoiceControl } from 'entities';

import { Column, Button } from 'components/Blocks';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';

function Package() {
  const {
    project: { invoice },
  } = useProjectProfile();

  if (!invoice.package) return null;

  const { id, name } = invoice.package;

  return (
    <Button to="packageProfile" params={{ packageId: id }} variant="link" color="gray">
      {name}
    </Button>
  );
}

function Standard() {
  const {
    project: { invoice },
  } = useProjectProfile();

  const { t } = useLang();

  return (
    <Column gap="2" alignItems="center">
      <span>
        {`> ${t('installments')}: `} <strong>{invoice.typeConfig?.installments}</strong>
      </span>

      {invoice.typeConfig?.comment && (
        <Column gap="1">
          <strong>{t('comments')}</strong>
          <span>{invoice.typeConfig.comment}</span>
        </Column>
      )}
    </Column>
  );
}

const components: Record<Exclude<ProjectInvoiceControl['type'], undefined>, typeof Package> = {
  PACKAGE: Package,
  STANDARD: Standard,
};

export function PaymentInfoDisplay() {
  const {
    project: { invoice },
  } = useProjectProfile();

  if (!invoice.type) return null;

  const Component = components[invoice.type];

  return <Component />;
}
